import { Box } from "@mui/material";
import { Text } from "$components";
import { theme } from "$utils/theme/bataillog";
import Block from "./Block";
import sections from "./sections";

const colorSection = sections.find((s) => s.id === "colors");

function Colors() {
  const colors = theme.color;
  return (
    <Block title={colorSection.label} id={colorSection.id}>
      <Box
        display="flex"
        style={{ gap: theme.spacing(2) }}
        flexWrap="wrap"
        justifyContent="space-evenly"
      >
        {Object.keys(colors)
          .sort((k1, k2) => k1.localeCompare(k2))
          .map((colorKey) => (
            <Box textAlign="center" key={colorKey}>
              <Box
                borderRadius={10}
                style={{ background: colors[colorKey] }}
                height={70}
                width={125}
                boxShadow={1}
                display="flex"
                alignItems="flex-end"
              >
                <p
                  style={{
                    background: "rgba(255,255,255,0.6)",
                    margin: 0,
                    width: "100%",
                  }}
                >
                  {colors[colorKey]}
                </p>
              </Box>
              <Text
                type="secondary"
                style={{ margin: 0, marginTop: theme.spacing(1) }}
              >
                {colorKey}
              </Text>
            </Box>
          ))}
      </Box>
    </Block>
  );
}

export default Colors;
